import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { resetPasswordUsingPhoneAction } from '../redux/attemptSurvey/attemptSurvey.actions';

export default function ResetPassword() {
    const [isShowPassword, setIsShowPassword] = useState(false);
    const [isShowConfirmPassword, setIsShowConfirmPassword] = useState(false);
    const [currentLanguage, setCurrentLanguage] = useState("");
    const [formData, setFormData] = useState({
        password: '',
        confirmPassword: ''
    });
    const [errors, setErrors] = useState({
        password: '',
        confirmPassword: ''
    });
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        setCurrentLanguage(localStorage.getItem("language"));
    }, []);

    const handleShowPassword = () => {
        setIsShowPassword(!isShowPassword)
    }

    const handleShowConfirmPassword = () => {
        setIsShowConfirmPassword(!isShowConfirmPassword)
    }

    const handleInputChange = (e, field) => {
        const value = e.target.value;
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
        setErrors(prev => ({
            ...prev,
            [field]: ''
        }));
    }

    const validateForm = () => {
        let isValid = true;
        const newErrors = {
            password: '',
            confirmPassword: ''
        };

        if (!formData.password) {
            newErrors.password = currentLanguage === "Italian"
                ? "La password è obbligatoria"
                : "Password is required";
            isValid = false;
        } else if (formData.password.length < 6) {
            newErrors.password = currentLanguage === "Italian"
                ? "La password deve contenere almeno 6 caratteri"
                : "Password must be at least 6 characters";
            isValid = false;
        }

        if (!formData.confirmPassword) {
            newErrors.confirmPassword = currentLanguage === "Italian"
                ? "La conferma della password è obbligatoria"
                : "Confirm password is required";
            isValid = false;
        } else if (formData.password !== formData.confirmPassword) {
            newErrors.confirmPassword = currentLanguage === "Italian"
                ? "Le password non corrispondono"
                : "Passwords do not match";
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const phone = JSON.parse(localStorage.getItem("registerData")).phone.toString();
        if (validateForm()) {
            dispatch(resetPasswordUsingPhoneAction({
                phone: phone,
                password: formData.password
            })).then(() => {
                navigate('/reset-successfully');
                localStorage.removeItem("registerData");
            }).catch(error => {
                console.error('Error resetting password:', error);
            });
        }
    }

    return (
        <div className='reser_password'>
            <div className="top_text mb5">
                {currentLanguage === "Italian" ? "Reimposta password" : "Reset Password"}
            </div>
            <div className="verification_code">
                {currentLanguage === "Italian"
                    ? "La nuova password deve essere diversa dalla precedente"
                    : "New password must be different from previous one"
                }
            </div>
            <div className="input_wrapper passowrd mb10">
                <input
                    type={isShowPassword ? 'text' : 'password'}
                    value={formData.password}
                    onChange={(e) => handleInputChange(e, 'password')}
                    placeholder={currentLanguage === "Italian" ? 'Password' : 'Password'}
                />
                <div className="pass_button" onClick={handleShowPassword}>
                    <img src={`${process.env.PUBLIC_URL}/images/${isShowPassword ? 'password_show' : 'password_hide'}.png`} alt="" />
                </div>
            </div>
            {errors.password && (
                <div className="error-text" style={{ color: 'red', fontSize: '12px', marginTop: '-8px', marginBottom: "8px" }}>
                    {errors.password}
                </div>
            )}
            <div className="input_wrapper passowrd mb10">
                <input
                    type={isShowConfirmPassword ? 'text' : 'password'}
                    value={formData.confirmPassword}
                    onChange={(e) => handleInputChange(e, 'confirmPassword')}
                    placeholder={currentLanguage === "Italian" ? 'Conferma Password' : 'Confirm Password'}
                />
                <div className="pass_button" onClick={handleShowConfirmPassword}>
                    <img src={`${process.env.PUBLIC_URL}/images/${isShowConfirmPassword ? 'password_show' : 'password_hide'}.png`} alt="" />
                </div>
            </div>
            {errors.confirmPassword && (
                <div className="error-text" style={{ color: 'red', fontSize: '12px', marginTop: '-8px', marginBottom: "8px" }}>
                    {errors.confirmPassword}
                </div>
            )}
            <div className="action">
                <Link onClick={handleSubmit}>
                    {currentLanguage === "Italian" ? "Aggiorna" : "Update"}
                </Link>
                <button className="cancel">
                    {currentLanguage === "Italian" ? "Annulla" : "Cancel"}
                </button>
            </div>
        </div>
    )
}
